class SignupForm extends HTMLElement {

  constructor() {
    super();

    this.input = this.querySelector('#signup-form');
    this.wrapper = this.querySelector('.js-signup-form-wrapper');
    this.form = this.querySelector('form');
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    this.success = this.querySelector('.js-newsletter-success');
    this.hideOnSubmit = this.querySelectorAll('.js-hide-on-submit');
    this.errorMessage = this.querySelector('.js-newsletter-error');
    this.variantWaitlistInput = this.querySelector('.js-variant-waitlist-input');
  }

  onSubmitHandler(evt) {
    evt.preventDefault();
    const submitButton = this.querySelector('[type="submit"]');
    if (submitButton.classList.contains('loading')) return;

    this.handleErrorMessage();

    submitButton.setAttribute('aria-disabled', true);
    submitButton.classList.add('loading');

    const params = new URLSearchParams({
      email: encodeURI(this.input.value),
      g: this.input.dataset.formId,
      $timezone_offset: ((new Date()).getTimezoneOffset() / 60 * -1.0).toString(),
      $source: '$embed',
      $fields: '$source',
    });
    const config = {
      headers: {
        'content-type': 'application/x-www-form-urlencoded;charset=utf-8'
      },
      method: 'POST',
      body: params.toString()
    };

    fetch('https://manage.kmail-lists.com/ajax/subscriptions/subscribe', config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          this.handleErrorMessage(response.description);
          return;
        }

        tatari.track('sign_up');

        this.success.classList.remove('hidden');

        this.hideOnSubmit.forEach(element => {
          element.classList.add('hidden');
        });
        
        this.input.classList.add('newsletter-success-state');
        this.input.disabled = true;
        submitButton.style.display = 'none';
        this.form.reset();

        if(gtag) {
          gtag("event", "newsletter_subscribe")
        }

      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        submitButton.classList.remove('loading');
        submitButton.removeAttribute('aria-disabled');
      });
  }

  handleErrorMessage(errorMessage = false) {
    if (errorMessage) {
      this.errorMessage.textContent = errorMessage;
      this.errorMessage.classList.remove('hidden');
    }
  }
}

customElements.define('signup-form', SignupForm);
